import React from 'react';
import './Navbar.css';
import ebay from '../resources/ebay_logo.png';
import traktorpool from '../resources/traktorpool.png';

import { FaPhoneSquareAlt } from "react-icons/fa";
import { FiMail } from "react-icons/fi";

interface INavbarProps {
}

interface INavbarState {
}

export default class Navabr extends React.Component<INavbarProps, INavbarState>{

    openEbay(){
        window.open('https://m.ebay-kleinanzeigen.de/s-anzeigen/deutschland/c0-l0?userIds=19263569', '_blank');
    }

    openTraktorpool(){
        window.open('https://www.traktorpool.de/vonohlen/', '_blank');
    }

    render() {
        return (
            <div id="navbar">
                <img id="tp" className="link-img" width="100px" src={ebay} alt="ebay Kleinanzeigen" onClick={this.openEbay} />
                <img id="ebay" className="link-img" width="100px" src={traktorpool} alt="Traktorpool" onClick={this.openTraktorpool} />
                <a id="callbutton" href="tel:+4917696715664" >
                    <FaPhoneSquareAlt className="icon"/>
                </a>
                <a id="mailbutton" href="mailto:Cord-von-Ohlen@t-online.de" >
                    <FiMail className="icon"/>
                </a>
            </div>
        )
    }

}